import { FC, ReactNode } from 'react'
import { Redirect, Route, RouteProps } from 'react-router-dom'

/**
 * ユーザーのみみれるページ。ログインしていなければ、ログインページに飛ばす。
 *
 */
export const PrivateRoute: FC<
  { element: ReactNode; isLogin: boolean } & RouteProps
> = ({ element, isLogin, ...rest }) => {
  return (
    <Route
      {...rest}
      render={({ location }) => {
        if (!isLogin)
          return (
            <Redirect
              to={{
                pathname: '/login',
                state: { from: location },
                search: `redirectUri=${encodeURIComponent(location.pathname)}`,
              }}
            />
          )
        return element
      }}
    />
  )
}
